import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomOcc } from '../../../../../../spartacus/custom/core/occ/occ-models/custom-occ.models';
import { B2BDocumentTypeList, InvoiceHistoryList, InvoicesFilter } from '../invoices.model';
import { CustomInvoiceAdapter } from './custom-invoice.adapter';
import { INVOICES_HISTORY_NORMALIZER, INVOICES_NORMALIZER } from './custom-invoices-converters';

@Injectable()
export class CustomOccInvoicesAdapter implements CustomInvoiceAdapter {
  constructor(protected http: HttpClient, protected occEndpoints: OccEndpointsService, protected converter: ConverterService) {}

  public loadDocumentTypes(): Observable<B2BDocumentTypeList> {
    const url = this.occEndpoints.buildUrl('documenttypes');
    return this.http.get<CustomOcc.InvoiceDocumentType>(url).pipe(this.converter.pipeable(INVOICES_NORMALIZER));
  }

  public loadHistory(userId: string, pageSize?: number, currentPage?: number, sort?: string, invoicesFilter?: InvoicesFilter): Observable<InvoiceHistoryList> {
    const params = {} as any;
    if (pageSize) {
      params['pageSize'] = pageSize.toString();
    }
    if (currentPage) {
      params['currentPage'] = currentPage.toString();
    }
    if (sort) {
      params['sort'] = sort.toString();
    }
    for (const key in invoicesFilter) {
      if (Object.prototype.hasOwnProperty.call(invoicesFilter, key)) {
        const element = invoicesFilter[key as keyof InvoicesFilter];
        if (element) {
          params[key] = element;
        }
      }
    }

    const url = this.occEndpoints.buildUrl('invoices', {
      urlParams: { userId },
      queryParams: params
    });

    return this.http.get<CustomOcc.InvoicesHistoryList>(url).pipe(this.converter.pipeable(INVOICES_HISTORY_NORMALIZER));
  }
}
